import React from 'react';
import padlock from 'images/padlock.svg';

function SettingsCurrentPlanForbiddenPath() {
  return (
    <div className='text-center m-auto'>
      <img className='mb-4' src={padlock} />

      <h3>
        Só administradores por aqui!
      </h3>

      <p className='mt-4 text-dark-gray width-6'>
        Esta seção é reservada para os ajustes gerais da conta. Por segurança,
         apenas quem tem permissão de administrador pode fazer alterações. 😉
      </p>
    </div>
  );
}

export default SettingsCurrentPlanForbiddenPath;
